import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { FullScreenModalContentComponent } from './full-screen-modal-content/full-screen-modal-content.component';
import { FullscreenContainerModalComponent } from './fullscreen-modal-container/fullscreen-container-modal.component';
import { FullscreenModalService } from './fullscreen-modal.service';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    FlexLayoutModule,
    FlexModule,
    MatProgressBarModule
  ],
  declarations: [FullscreenContainerModalComponent, FullScreenModalContentComponent],
  entryComponents: [FullscreenContainerModalComponent, FullScreenModalContentComponent],
  exports: [FullscreenContainerModalComponent, FullScreenModalContentComponent],
  providers: [FullscreenModalService]
})
export class FullscreenModalModule { }
